import { render, staticRenderFns } from "./smsSubscription.vue?vue&type=template&id=4edf2eb6&scoped=true"
import script from "./smsSubscription.vue?vue&type=script&lang=js"
export * from "./smsSubscription.vue?vue&type=script&lang=js"
import style0 from "./smsSubscription.vue?vue&type=style&index=0&id=4edf2eb6&prod&scoped=true&lang=scss"
import style1 from "./smsSubscription.vue?vue&type=style&index=1&id=4edf2eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf2eb6",
  null
  
)

export default component.exports